/** Widths for images that span the screen, as Next.js `deviceSizes`. */
export const DEVICE_WIDTHS = [640, 750, 828, 1080, 1200, 1920, 2048, 3840];

/** Widths for small images (thumbnails, icons), as Next.js `imageSizes`. */
export const IMAGE_WIDTHS = [16, 32, 48, 64, 96, 128, 256, 384];

const ALL_WIDTHS = [...IMAGE_WIDTHS, ...DEVICE_WIDTHS];
const VIEWPORT_WIDTH_PATTERN = /(^|\s)(1?\d?\d)vw/g;

/**
 * Candidate widths of a `srcset`, as Next.js `getWidths`: when `sizes` uses `vw`, widths too small for the
 * smallest viewport share on the smallest device are dropped; with fixed sizes, every width is kept.
 */
export const getSrcSetWidths = (sizes: string) => {
	const viewportPercents = [...sizes.matchAll(VIEWPORT_WIDTH_PATTERN)].map(match =>
		Number(match[2])
	);

	if (viewportPercents.length === 0) {
		return ALL_WIDTHS;
	}

	const smallestViewportShare = Math.min(...viewportPercents) / 100;
	const smallestUsefulWidth = DEVICE_WIDTHS[0] * smallestViewportShare;

	return ALL_WIDTHS.filter(width => width >= smallestUsefulWidth);
};
